import { useTranslation } from "react-i18next";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { LicenceLeftMenu } from "../components/LicenceLeftMenu";
import { DownloadFileByFileStoreId } from "../components/DownloadFileByFileStoreId";

const Current_Circular_Notes_Guidelines = () => {
  const { t } = useTranslation();
  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />
        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
        </div>
      </section>
      {/* End Slider */}
      <section className="section inner-pad1">
        <div className="container ">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu  min-height-400">
                <LicenceLeftMenu />
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container">
                <div className="row">
                  <div className="inner-title2">
                    <h3 className="fontSizeClass">
                      {t("Current Circular Notes & Guidelines")}
                    </h3>
                  </div>
                  <div className="about-head1">
                    <div className="border border-dark p-1 mb-4">
                      {[
                        {
                          fileStoreId: "4e1e0553-871e-4a36-b6d1-96020538df67",
                          label:
                            "Modalities of Corrections of Name of Certificate of Enlistment Holder",
                        },
                        {
                          fileStoreId: "f26e6458-c804-4690-9c43-6b9b7125512c",
                          label:
                            "Notification regarding Hookah Bar / Cafe / Parlour etc.",
                        },
                        {
                          fileStoreId: "45926483-ff92-4252-b10b-cbbc1007bb15",
                          label:
                            "Notification for Misplacing of Bailiff Books.",
                        },
                        {
                          fileStoreId: "e0feee33-7e35-4377-b599-b279c8ad3876",
                          label:
                            "Guidelines for enlistment of Profession, Trade and Calling in the Kolkata Municipal Corporation areas in exercise of the power conferred by Section 199 of the Kolkata Municipal Corporation Act, 1980 (West Ben. Act LIX of 1980).",
                        },
                        {
                          fileStoreId: "350caf31-1bbb-4ca0-935c-cad1d32a647d",
                          label:
                            "All traders/businessmen may take notice that use of plastic carry bags below 50(fifty) microns is strictly prohibited and punishable under law.",
                        },
                        {
                          fileStoreId: "9bae8b52-23c4-4898-97dd-9e097f832c95",
                          label:
                            "Circular of WBPCB Memo No:1102/383L/WPB/2017 in respect of Ceremonial House.",
                        },
                      ].map(({ fileStoreId, label }, index, arr) => (
                        <div
                          className={`border border-dark d-flex flex-row justify-content-center text-center ${
                            index !== arr.length - 1 ? "mb-1" : ""
                          }`}
                          style={{fontSize: "14px"}}
                          key={index}
                        >
                          <DownloadFileByFileStoreId
                            fileStoreId={fileStoreId}
                            label={label}
                          />
                        </div>
                      ))}
                    </div>
                    <div className="border border-dark p-1 mb-4">
                      {[
                        {
                          fileStoreId: "c62d93e0-26b8-4a0c-948a-fc2e445ed0a6",
                          label:
                            "Regulations for premises permitted to let out for holding Ceremonial House.",
                        },
                      ].map(({ fileStoreId, label }, index) => (
                        <div
                          className="border border-dark d-flex flex-row justify-content-center text-center"
                          key={index}
                        >
                          <DownloadFileByFileStoreId
                            fileStoreId={fileStoreId}
                            label={label}
                          />
                        </div>
                      ))}
                    </div>
                    <div className="border border-dark p-1">
                      <p className="fontSizeClass border border-dark p-1 font-weight-bold">
                        {t(
                          "For Trades liable to pay Water Supply Fees & Drainage fees separately"
                        )}
                        <ol className="kmc-function-list" type="i">
                          {[
                            "For ICI consumers, Receipt of current years Water Supply Fees along with receipt of current year's Drainage & Sewerage Fees.",
                            "For ICI consumers, Receipt of current years Water Supply Fees along with receipt of current year's Drainage & Sewerage Fees.",
                          ].map((item, index) => (
                            <li key={index}>{item}</li>
                          ))}
                        </ol>
                        {t(
                          "On production of such original receipts along with photocopies the Licence Department undertakes necessary adjustment of fees in CE as per prevailing norms/practice"
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Current_Circular_Notes_Guidelines;
